import { CurrencyEnum } from '../models/enums/currency.enum';

export const formatAmountToFixedCurrency = (amount: number, currency: string | CurrencyEnum = CurrencyEnum.SEK, decimals = 2) => {
  // Konvertera beloppet till en sträng med önskat antal decimaler
  const amountToFixed = amount < 1 ? '0' : Number(amount).toFixed(decimals);

  // Separera hela delen och decimaldelen
  const [integerPart, decimalPart] = amountToFixed.split('.');

  // Lägg till tusentalsavgränsare till den hela delen och hantera eventuell omtilldelning
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  // Återskapa talet med komma som decimalavgränsare och lägg till ' kr' på slutet
  return `${formattedIntegerPart},${decimalPart || '00'} ${currency}`;
};

// Nedan regex funkar inte i äldre webbläsare pga negativ lookbehind ((?<!...))
// export const formatAmountToFixedKr = (amount: number, decimals oga  = 2) => {
//   let amountToFixed = amount < 1 ? '0' : Number(amount).toFixed(decimals);
//   if (amount > 0) amountToFixed = String(amountToFixed).replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1 ');
//   return `${amountToFixed.replace('.', ',')} kr`;
// };

export const formatAmount = (amount: number) => {
  // Konvertera beloppet till en sträng med önskat antal decimaler
  const amountToFixed = Number(amount).toFixed(0);

  // Separera hela delen och decimaldelen
  const [integerPart, decimalPart] = amountToFixed.split('.');

  // Lägg till tusentalsavgränsare till den hela delen och hantera eventuell omtilldelning
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  // Återskapa talet med komma som decimalavgränsare och lägg till ' kr' på slutet
  return `${formattedIntegerPart}`;
};
